import { getPriceFeeds } from '@/actions'
import { MainContainer } from '@/components/atoms'
import { PriceFeedsList } from '@/components/organisms'
import { Layout } from '@/components/templates'
import { Heading } from '@chakra-ui/react'
import { useQuery } from '@tanstack/react-query'

export const PriceFeeds = () => {
  const { data: priceFeeds, isLoading } = useQuery({
    queryKey: ['price-feeds'],
    queryFn: () => getPriceFeeds(),
  })

  return (
    <Layout withBackButton>
      <MainContainer>
        <Heading mb={8}>Available Price Feeds</Heading>

        <PriceFeedsList
          isLoading={!priceFeeds || isLoading}
          items={priceFeeds}
        />
      </MainContainer>
    </Layout>
  )
}
